import './index.sass';

export default () => {
  $('.search-select.js-select').on('change', function () {
    $(this).find('option').filter((index,item) => {
      if($(this).val() === $(item).val()){
        if($(item).data('href').length) {
          $(this).attr('data-href', $(item).data('href'));
          const link = $(this).attr('data-href');
          window.location.href = link;
        }
      }
    })
  });
}